import { ROLES } from './types';

const ALL_ROLES = [ROLES.reporter, ROLES.viewer, ROLES.fixedRatesEditor];

export default ALL_ROLES;
